export default __webpack_public_path__ + "static/media/pic1.f55c1897.jpg";